export default function insertCountryAndAssetTypeColumnsSpecification(config) {
    if (!config.data) return null;

    let result = {};
    let tableData = [];
    const { countrySpecificCostMargins = [] } = config.data;

    countrySpecificCostMargins.map((countryCostMargin, rowIndex) => {

        let row = [];
        const rowId = config.tableType + "|" + rowIndex;

        config.columns.forEach(column => {
            const columnId = column.id;
            const columnDataType = column.data.displayInBodyAs;
            let columnValue = null;
            let columnValueData = {};
            let disabled = false;

            if (columnDataType === "string") {
                if (columnId === "countryCode") {
                    columnValue = countryCostMargin.countryCode || "";
                }
                else if (columnId === "assetType") {
                    columnValue = countryCostMargin.assetType || "";
                }
            }
            else if (columnDataType === "input") {
                if (columnId === 'hardwareDownlift') {
                    columnValue = countryCostMargin.hardwareDownlift;
                }
                else if (columnId === 'logisticUplift') {
                    columnValue = countryCostMargin.logisticUplift;
                }
                else if (columnId === 'processingUplift') {
                    columnValue = countryCostMargin.processingUplift;
                }

                columnValueData = { defaultValue: columnValue, ...column.data };
            }

            row.push({
                [columnId]: {
                    id: columnId + "|" + rowId,
                    columnId: columnId,
                    useIdAttribute: true,
                    type: columnDataType,
                    value: columnValue || columnValueData,
                    width: column.width,
                    disabled: disabled,
                    displayAsIs: column.data.displayInBodyAsIs,
                    showInMobileViewAs: column.showInMobileViewAs,
                    highlightColumn: column.data.highlightBodyText,
                    clickHandler: event => config.bodyButtonsHandler(event, columnId, rowIndex)
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });
    });

    result['columns'] = config.columns;
    result['data'] = tableData;

    return result;
}

